import React, { Component } from "react";
import "./style.less";
import cx from "classnames";
import { getDate } from "../../../utils/helper";
import CustomSlider from "./CustomSlider";
import { IconButton } from "@material-ui/core";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";

class MonthSlider extends Component {
  constructor(props) {
    super(props);
    const selectedAsOfDateYear = props.selectedDate
      ? new Date(props.selectedDate).getFullYear()
      : new Date().getFullYear();
    this.state = {
      monthArrowShiftVa: 12, // move slider for one year gap
      selectedDate: props.selectedDate,
      currentYear: new Date().getFullYear(),
      selectedYear: selectedAsOfDateYear,
      minSliderVal: getDate(`1/10/${selectedAsOfDateYear}`),
      maxSliderVal: getDate(`12/10/${selectedAsOfDateYear}`),
      allCleared: props.allCleared
    };
  }

  componentWillReceiveProps(nextProps) {
    const { allCleared } = this.state;
    if (allCleared !== nextProps.allCleared) {
      this.setState({
        selectedYear: new Date().getFullYear(),
        allCleared: nextProps.allCleared
      });
    }
  }

  /** call when click on previous year/month select */
  setPrevYear = () => {
    const {
      selectedYear,
      minSliderVal,
      maxSliderVal,
      monthArrowShiftVa
    } = this.state;

    const minVal = new Date(minSliderVal.setDate(10));
    const maxVal = new Date(maxSliderVal.setDate(10));

    this.setState({
      minSliderVal: this.getPrevNextDate(minVal, monthArrowShiftVa * -1),
      maxSliderVal: this.getPrevNextDate(maxVal, monthArrowShiftVa * -1),
      selectedYear: selectedYear - 1
    });
  };

  /** call when click on next year/month select */
  setNextYear = () => {
    const {
      selectedYear,
      minSliderVal,
      maxSliderVal,
      monthArrowShiftVa
    } = this.state;
    const minVal = new Date(minSliderVal.setDate(10));
    const maxVal = new Date(maxSliderVal.setDate(10));

    this.setState({
      minSliderVal: this.getPrevNextDate(minVal, monthArrowShiftVa),
      maxSliderVal: this.getPrevNextDate(maxVal, monthArrowShiftVa),
      selectedYear: selectedYear + 1
    });
  };

  getPrevNextDate = (date, gapVal) => {
    date.setMonth(date.getMonth() + gapVal);
    return getDate(date.toLocaleDateString("en-US"));
  };

  /** disable previous and next button */
  getArrowDisable = sliderView => {
    const { selectedYear, currentYear } = this.state;
    const yearGap = currentYear - selectedYear; // disable future year
    switch (sliderView) {
      case "year":
        return { leftArrowDisable: false, rightArrowDisable: yearGap === 0 };
      case "mtdRadio":
        return { leftArrowDisable: false, rightArrowDisable: yearGap === 0 };
      case "ytdRadio":
      case "ttmRadio":
        return { leftArrowDisable: false, rightArrowDisable: yearGap === 0 };
      default:
        return { leftArrowDisable: true, rightArrowDisable: true };
    }
  };

  /** update the selected year field if case of yearly selection and call onchange method of slider */
  onChangeMonthRange = (startMonth, endMonth) => {
    const endDateInDateFormat = new Date(endMonth);
    const { sliderView, onChangeMonthRange } = this.props;
    const { minSliderVal } = this.props;
    const updatedDate = getDate(
      endDateInDateFormat.toLocaleDateString("en-US")
    );
    if (
      sliderView === "year" &&
      updatedDate.toLocaleDateString("en-US") !==
        minSliderVal?.toLocaleDateString("en-US")
    ) {
      this.setState({ selectedYear: updatedDate.getFullYear() });
    }

    onChangeMonthRange(startMonth, endMonth);
  };

  render() {
    const {
      selectedYear,
      selectedDate,
      minSliderVal,
      maxSliderVal
    } = this.state;
    const {
      sliderView,
      singleTickSelection,
      defaultYearSelectionGap: defaultYearSelectionGap,
      startDate,
      endDate,
      isViewReport,
      allCleared
    } = this.props;
    const arrow = this.getArrowDisable(sliderView);
    return (
      <div className={"row slider-container"}>
        <div
          className={
            "col-xs-1 col-sm-1 col-md-1 col-lg-1 yearChanger no-padding"
          }
        >
          <IconButton
            aria-label={"delete"}
            className={
              cx(arrow.leftArrowDisable && "disable-arrow") + " slider-arrow"
            }
            size={"medium"}
            onClick={this.setPrevYear}
            key={"leftArrow"}
          >
            <ArrowLeftIcon size={"medium"} />
          </IconButton>
        </div>
        <div className={"col-xs-10 col-sm-10 col-md-10 col-lg-10 sliderBox"}>
          <CustomSlider
            key={"customSlider"}
            allCleared={allCleared}
            isViewReport={isViewReport}
            startDate={startDate}
            endDate={endDate}
            selectedYear={selectedYear}
            onChangeMonthRange={this.onChangeMonthRange}
            selectedDate={selectedDate}
            sliderView={sliderView}
            minSliderVal={minSliderVal}
            maxSliderVal={maxSliderVal}
            singleTickSelection={singleTickSelection}
            defaultYearSelectionGap={defaultYearSelectionGap}
          />
        </div>
        <div
          className={
            "col-xs-1 col-sm-1 col-md-1 col-lg-1 yearChanger no-padding"
          }
        >
          <IconButton
            key={"rightArrow"}
            aria-label={"delete"}
            size={"medium"}
            className={
              cx(arrow.rightArrowDisable && "disable-arrow") + " slider-arrow"
            }
            onClick={this.setNextYear}
          >
            <ArrowRightIcon size={"medium"} />
          </IconButton>
        </div>
      </div>
    );
  }
}

export default MonthSlider;
